import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import{CellDataRenderComp_Assess}from 'src/app/assessment/assessment-home/CellDataRenderComp_Assess'
import {AppComponent} from 'src/app/app.component';
import { VulClass } from 'src/app/Data Service/VulClass';
import { RolegaurdService } from 'src/app/Data Service/rolegaurd.service';
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { NewVulnerabilityService } from 'src/app/Data Service/new-vulnerability.service';
import { newAssessClass } from 'src/app/Data Service/newAssessClass';

@Component({
  selector: 'app-assessment-home',
  templateUrl: './assessment-home.component.html',
  styleUrls: ['./assessment-home.component.css']
})
export class AssessmentHomeComponent implements OnInit {

// ng smartdatatable
name:string; 
data : any[];
rdata : any[]=[];

public errorMessage: string = '';

settings = {
  columns: {
    DateRaised_Home: {
       title: 'Date Raised',
       placeholder: "search",
      valuePrepareFunction: (DateRaised: any) => {
        return new DatePipe('en-US').transform(DateRaised, 'dd-MM-yyyy')
      },
      width: '10%',      
    },

    ARef_Home: {
       title: 'GCC Ref',
      //type: 'html',
      type: 'custom',
      renderComponent : CellDataRenderComp_Assess,
width: '10%'
    },
    Client_Home: {
       title: 'Client',
      width: '20%',
      
    },
    ContractNumber_Home: {
      title: 'Contract',
     width: '20%',
     
   },
   ContractName_Home: {
    title: 'Contract Name',
   width: '20%',
   
 },
 AssessmentName_Home: {
       title: 'Assessment Name',
      width: '60%'      
    }
  },
  
  pager: {
    display: true,
    perPage: 15,
    outerHeight:15,
  },
  actions: {
    add: false,
    delete: false,
    edit: false,     
  },  
  
};


constructor(public service : NewVulnerabilityService,private router: Router,
  private authService: MsalService, private msalBroadcastService: MsalBroadcastService 
  ,private appComp : AppComponent,private activatedRoute : ActivatedRoute
  ,private _roleGaurd : RolegaurdService) { }

  appUser() : boolean{
    const isUser = this._roleGaurd.appUser();    
    return isUser;
  }

  appAdmin() : boolean{
    const isAdmin = this._roleGaurd.appAdmin();    
    return isAdmin;
  }

  loadGridData(){

    this.data = [{      
      DateRaised_Home: "",
      ARef_Home: "",
      Client_Home: "",
      ContractNumber_Home: "",
      ContractName_Home: "",
      AssessmentName_Home: "",  
    }];  
      this.service.getAssessGridData().subscribe((data : any)=>{  
        console.log(data)    
      this.data = data as newAssessClass[];  
    }, (error:any) => {
      this.errorMessage = error;
  })

}

  ngOnInit(): void {
    this.service.refreshNeeded$
    .subscribe(() => {
      this.loadGridData();
    });
    this.loadGridData();
  }

}
